import { useLocalStorage } from '@mantine/hooks';

import type { MatchedColumns } from '../types.ts';

export function useMatchedColumns(isInvoiceMode: boolean) {
  const storageKey = `csv-${isInvoiceMode ? 'invoice' : 'debtor'}-import-matched-columns`;
  const [matchedColumns, setMatchedColumns] = useLocalStorage<MatchedColumns>({
    key: storageKey,
    defaultValue: [],
  });

  return { matchedColumns, setMatchedColumns };
}
